/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "../../../services/googleAnalyticsService";

const LpTenancyLawAdvocardMeta = () => {
  const title = "Professionelle Hilfe im Mietrecht | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Professionelle Hilfe im Mietrecht - Schnell, einfach und sicher! Jetzt beraten lassen!" />
      <meta name="robots" content="index,follow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Professionelle Hilfe im Mietrecht - Schnell, einfach und sicher! Jetzt beraten lassen!" />
    </Helmet>
  );
};

export default LpTenancyLawAdvocardMeta;
